module.exports = __webpack_public_path__ + "static/media/interior6.77e78096.svg";